export const UserMenu = {
  routes: [
    {
      name: 'users',
      displayName: 'menu.users',
      subject_class: "Users"
    },
    {
      name: 'roles',
      displayName: 'menu.roles',
      subject_class: "Roles"
    },
  ]
} 

        

